import { useState } from 'react';
import { RenderUnsettledUI } from 'shared/components';
import { AvailabilityFilters } from './availability-filters';
import { AppliedAvailabilityFilters } from './filters.types';
import { useGetCompanyFlexpools } from '../hooks/use-get-company-flexpools';
import { useGetCompanies } from '../../../../hq/hooks/queryHooks/companies/use-get-companies';
import { useSiteDetection } from '../../../hooks';

type AvailabilityFilterDataProviderOptions = {
  isOpen: boolean;
  toggleFilters: () => void;
  handleFiltersChange: (filters: AppliedAvailabilityFilters) => void;
  currentFilters: string[];
  currentCompany?: { value: string; label: string };
  currentAllFlexpoolsSelected: boolean;
};

export const AvailabilityFilterDataProvider = ({
  isOpen,
  toggleFilters,
  handleFiltersChange,
  currentFilters,
  currentCompany,
  currentAllFlexpoolsSelected,
}: AvailabilityFilterDataProviderOptions) => {
  const { site } = useSiteDetection();
  const [companyInput, setCompanyInput] = useState<string>('');
  const companyQueryEnabled = site === 'hq' && companyInput.length >= 3;
  const companiesQuery = useGetCompanies(companyInput, false, undefined, companyQueryEnabled);
  const [company, setCompany] = useState(currentCompany);
  const flexpoolsQuery = useGetCompanyFlexpools(company?.value);

  const isSiteOgp = site === 'ogp';
  const isFlexPoolDataFilled = flexpoolsQuery.status === 'success';

  if (isSiteOgp && !isFlexPoolDataFilled) {
    return <RenderUnsettledUI data={flexpoolsQuery} />;
  }

  if (!isOpen) {
    return null;
  }

  const handleCancel = () => {
    setCompany(currentCompany);
    toggleFilters();
  };

  return (
    <AvailabilityFilters
      companyFlexPools={flexpoolsQuery.data || { flexPools: [] }}
      companies={companiesQuery.data || []}
      company={company}
      allFlexpoolsSelected={currentAllFlexpoolsSelected}
      isFlexPoolDataFilled={isFlexPoolDataFilled}
      isOpen={isOpen}
      handleCancel={handleCancel}
      toggleFilters={toggleFilters}
      setCompany={setCompany}
      handleFiltersChange={handleFiltersChange}
      currentFilters={currentFilters}
      setCompanyInput={setCompanyInput}
      companyInput={companyInput}
    />
  );
};
